import { Grid, Paper, Typography, Link as MuiLink, CircularProgress, Button } from "@material-ui/core";
import React, { useState } from "react";
import CheckIcon from "@material-ui/icons/Check";

export const TipTapReportDownload = ({
  data,
  editor,
  handleClose,
}: any) => {

  const [isDownloading, setIsDownloading] = useState(false);

  const selectedWorkorder = data?.[0];
  const [selectedSerials, setSelectedSerials] = useState<string[]>([]);
  const [selectedSequences, setSelectedSequences] = useState<string[]>([]);
  const [selectedProcedures, setSelectedProcedures] = useState<string[]>([]);

  const [serialExpanded, setSerialExpanded] = useState(false);
  const [sequenceExpanded, setSequenceExpanded] = useState(false);
  const [procedureExpanded, setProcedureExpanded] = useState(false);
  const [imageExpanded, setImageExpanded] = useState(false);

  const [selectedImages, setSelectedImages] = useState<any[]>([]);

  const handleInsert = () => {
    console.log("Editor:", editor);
    console.log("Selected Images:", selectedImages);

    if (!editor || selectedImages.length === 0) return;

    selectedImages.forEach((image) => {
      editor
        .chain()
        .focus()
        .setImage({
          src: image.image_url,
          alt: image.image_name,
        })
        .createParagraphNear()
        .run();
    });

    handleClose();
  };




  // Toggle serial selection
  const handleSerialToggle = (serial: string) => {
    setSelectedSerials((prev) => {
      let updated: string[];

      if (prev.includes(serial)) {
        // Deselect case
        updated = prev.filter((s) => s !== serial);

        // Clear dependent selections when serials change
        setSelectedSequences([]);
        setSelectedProcedures([]);

        setSequenceExpanded(false);
        setProcedureExpanded(false);
      } else {
        // Select case
        updated = [...prev, serial];

        setSelectedSequences([]);
        setSelectedProcedures([]);

        setSequenceExpanded(false);
        setProcedureExpanded(false);
      }

      return updated;
    });
  };

  // Toggle sequence (procedure_name) selection
  const handleSequenceToggle = (sequence: string) => {
    setSelectedSequences((prev) => {
      let updated: string[];

      if (prev.includes(sequence)) {
        // Deselect case
        updated = prev.filter((s) => s !== sequence);

        // Clear dependent procedures when sequences change
        setSelectedProcedures([]);
        setProcedureExpanded(false);
      } else {
        // Select case
        updated = [...prev, sequence];

        // Also clear procedures since new sequences may have different ones
        setSelectedProcedures([]);
        setProcedureExpanded(false);
      }

      return updated;
    });
  };

  // Toggle procedure_definition_name selection
  const handleProcedureToggle = (procedure: string) => {
    setSelectedProcedures((prev) =>
      prev.includes(procedure)
        ? prev.filter((p) => p !== procedure)
        : [...prev, procedure],
    );
  };
  return (
    <>


      {/* Select Serial Numbers */}
        <Paper elevation={2} style={{ padding: "10px", margin: "10px" }}>
          <Grid container spacing={1} direction="column">
            <Grid item xs={12} container alignItems="center" spacing={3}>
              <Grid item>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <Typography
                      variant="subtitle1"
                      style={{ color: "#800280", fontSize: "16px" }}
                    >
                      Select Serial Numbers
                    </Typography>
                  </Grid>
                  {serialExpanded && (
                    <Grid item>
                      <Typography
                        variant="body2"
                        style={{ color: "#800280", fontSize: "16px" }}
                      >
                        ({selectedSerials.length} selected of{" "}
                        {selectedWorkorder?.details.length || 0})
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {serialExpanded && (
                <Grid item>
                  <MuiLink
                    style={{ cursor: "pointer", fontSize: 14 }}
                    onClick={() => {
                      const allSerials =
                        selectedWorkorder?.details.map(
                          (d: any) => d.serial_numbers,
                        ) || [];
                      if (selectedSerials.length === allSerials.length) {
                        setSelectedSerials([]);
                      } else {
                        setSelectedSerials(allSerials);
                      }
                    }}
                  >
                    {selectedSerials.length ===
                      selectedWorkorder?.details.length
                      ? "Deselect All"
                      : "Select All"}
                  </MuiLink>
                </Grid>
              )}
              <Grid item style={{ marginLeft: "auto" }}>
                <MuiLink
                  style={{ cursor: "pointer", fontSize: 14 }}
                  onClick={() => setSerialExpanded(!serialExpanded)}
                >
                  {serialExpanded ? "Hide All" : "View All"}
                </MuiLink>
              </Grid>
            </Grid>

            {serialExpanded && (
              <Grid item>
                <Grid container spacing={1}>
                  {selectedWorkorder?.details.map((detail: any) => {
                    const serial = detail.serial_numbers;
                    const isSelected = selectedSerials.includes(serial);
                    return (
                      <Grid item key={serial}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent={isSelected ? "flex-start" : "center"}
                          onClick={() => handleSerialToggle(serial)}
                          style={{
                            minWidth: 100,
                            padding: "6px 12px",
                            border: isSelected
                              ? "1px solid #FFD27F"
                              : "1px solid #ccc",
                            backgroundColor: isSelected
                              ? "#FFD27F"
                              : "transparent",
                            color: "#000",
                            borderRadius: 10,
                            cursor: "pointer",
                            display: "flex",
                            gap: isSelected ? 4 : 0,
                            userSelect: "none",
                          }}
                        >
                          {isSelected && <CheckIcon fontSize="small" />}
                          <span
                            style={{
                              flex: 1,
                              textAlign: isSelected ? "left" : "center",
                            }}
                          >
                            {serial}
                          </span>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Paper>
     

      {/* Select Sequence */}
      {selectedWorkorder !== null && selectedSerials.length > 0 && (
        <Paper elevation={2} style={{ padding: "10px", margin: "10px" }}>
          <Grid container spacing={1} direction="column">
            <Grid item xs={12} container alignItems="center" spacing={3}>
              <Grid item>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <Typography
                      variant="subtitle1"
                      style={{ color: "#800280", fontSize: "16px" }}
                    >
                      Select Sequence for Selected Serials
                    </Typography>
                  </Grid>

                  {sequenceExpanded && (
                    <Grid item>
                      <Typography
                        variant="body2"
                        style={{ color: "#800280", fontSize: "16px" }}
                      >
                        ({selectedSequences.length} selected of{" "}
                        {(() => {
                          const selectedDetails =
                            selectedWorkorder?.details.filter((d: any) =>
                              selectedSerials.includes(d.serial_numbers),
                            ) || [];

                          const allSequencesPerSerial = selectedDetails.map(
                            (d: any) =>
                              d.procedures.map((p: any) => p.procedure_name),
                          );

                          const commonSequences =
                            allSequencesPerSerial.length > 0
                              ? allSequencesPerSerial.reduce(
                                (a: string[], b: string[]) =>
                                  a.filter((x) => b.includes(x)),
                              )
                              : [];

                          return commonSequences.length;
                        })()}
                        )
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {sequenceExpanded && (
                <Grid item>
                  <MuiLink
                    style={{ cursor: "pointer", fontSize: 14 }}
                    onClick={() => {
                      const selectedDetails =
                        selectedWorkorder?.details.filter((d: any) =>
                          selectedSerials.includes(d.serial_numbers),
                        ) || [];

                      const allSequencesPerSerial = selectedDetails.map(
                        (d: any) =>
                          d.procedures.map((p: any) => p.procedure_name),
                      );

                      // Find common procedure_names across all selected serials
                      const commonSequences =
                        allSequencesPerSerial.length > 0
                          ? allSequencesPerSerial.reduce(
                            (a: string[], b: string[]) =>
                              a.filter((x) => b.includes(x)),
                          )
                          : [];

                      if (selectedSequences.length === commonSequences.length) {
                        setSelectedSequences([]);
                      } else {
                        setSelectedSequences(commonSequences);
                      }
                    }}
                  >
                    {(() => {
                      const selectedDetails =
                        selectedWorkorder?.details.filter((d: any) =>
                          selectedSerials.includes(d.serial_numbers),
                        ) || [];
                      const allSequencesPerSerial = selectedDetails.map(
                        (d: any) =>
                          d.procedures.map((p: any) => p.procedure_name),
                      );
                      const commonSequences =
                        allSequencesPerSerial.length > 0
                          ? allSequencesPerSerial.reduce(
                            (a: string[], b: string[]) =>
                              a.filter((x) => b.includes(x)),
                          )
                          : [];
                      return selectedSequences.length === commonSequences.length
                        ? "Deselect All"
                        : "Select All";
                    })()}
                  </MuiLink>
                </Grid>
              )}

              <Grid item style={{ marginLeft: "auto" }}>
                <MuiLink
                  style={{ cursor: "pointer", fontSize: 14 }}
                  onClick={() => setSequenceExpanded(!sequenceExpanded)}
                >
                  {sequenceExpanded ? "Hide All" : "View All"}
                </MuiLink>
              </Grid>
            </Grid>

            {sequenceExpanded && (
              <Grid item>
                <Grid container spacing={1}>
                  {(() => {
                    const selectedDetails =
                      selectedWorkorder?.details.filter((d: any) =>
                        selectedSerials.includes(d.serial_numbers),
                      ) || [];

                    // Get all procedure_name arrays for each selected serial
                    const allSequencesPerSerial = selectedDetails.map(
                      (d: any) =>
                        d.procedures.map((p: any) => p.procedure_name),
                    );

                    // Find common procedure_names across all selected serials
                    const commonSequences =
                      allSequencesPerSerial.length > 0
                        ? allSequencesPerSerial.reduce(
                          (a: string[], b: string[]) =>
                            a.filter((x) => b.includes(x)),
                        )
                        : [];

                    return commonSequences.map((sequence: string) => {
                      const isSelected = selectedSequences.includes(sequence);
                      return (
                        <Grid item key={sequence}>
                          <Grid
                            container
                            alignItems="center"
                            justifyContent={
                              isSelected ? "flex-start" : "center"
                            }
                            onClick={() => handleSequenceToggle(sequence)}
                            style={{
                              minWidth: 150,
                              padding: "6px 12px",
                              border: isSelected
                                ? "1px solid #FFD27F"
                                : "1px solid #ccc",
                              backgroundColor: isSelected
                                ? "#FFD27F"
                                : "transparent",
                              color: "#000",
                              borderRadius: 10,
                              cursor: "pointer",
                              display: "flex",
                              gap: isSelected ? 4 : 0,
                              userSelect: "none",
                            }}
                          >
                            {isSelected && <CheckIcon fontSize="small" />}
                            <span
                              style={{
                                flex: 1,
                                textAlign: isSelected ? "left" : "center",
                              }}
                            >
                              {sequence}
                            </span>
                          </Grid>
                        </Grid>
                      );
                    });
                  })()}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Paper>
      )}

      {/* Select Procedure */}
      {selectedWorkorder && selectedSequences.length > 0 && (
        <Paper elevation={2} style={{ padding: "10px", margin: "10px" }}>
          <Grid container spacing={1} direction="column">
            <Grid item xs={12} container alignItems="center" spacing={3}>
              <Grid item>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item>
                    <Typography
                      variant="subtitle1"
                      style={{ color: "#800280", fontSize: "16px" }}
                    >
                      Select Procedure For Selected Sequence
                    </Typography>
                  </Grid>
                  {procedureExpanded && (
                    <Grid item>
                      <Typography
                        variant="body2"
                        style={{ color: "#800280", fontSize: "16px" }}
                      >
                        <Typography
                          variant="body2"
                          style={{ color: "#800280", fontSize: "14px" }}
                        >
                          ({selectedProcedures.length} selected of{" "}
                          {(() => {
                            const selectedDetails =
                              selectedWorkorder?.details.filter((d: any) =>
                                selectedSerials.includes(d.serial_numbers),
                              ) || [];

                            const allProceduresPerSerial = selectedDetails.map(
                              (d: any) => {
                                const serialProcedures = d.procedures
                                  .filter((p: any) =>
                                    selectedSequences.includes(
                                      p.procedure_name,
                                    ),
                                  )
                                  .flatMap(
                                    (p: any) =>
                                      p.procedure_definition_details || [],
                                  )
                                  .map((p: any) => p.procedure_definition_name);

                                return Array.from(new Set(serialProcedures));
                              },
                            );

                            const commonProcedures =
                              allProceduresPerSerial.length > 0
                                ? allProceduresPerSerial.reduce(
                                  (a: string[], b: string[]) =>
                                    a.filter((x) => b.includes(x)),
                                )
                                : [];

                            return commonProcedures.length;
                          })()}
                          )
                        </Typography>
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              {/* ✅ Select / Deselect All Link (shown only when expanded) */}
              {procedureExpanded && (
                <Grid item>
                  <MuiLink
                    style={{ cursor: "pointer", fontSize: 14 }}
                    onClick={() => {
                      const selectedDetails =
                        selectedWorkorder?.details.filter((d: any) =>
                          selectedSerials.includes(d.serial_numbers),
                        ) || [];

                      // Collect all procedures per serial for selected sequences
                      const allProceduresPerSerial = selectedDetails.map(
                        (d: any) => {
                          return d.procedures
                            .filter((p: any) =>
                              selectedSequences.includes(p.procedure_name),
                            )
                            .flatMap(
                              (p: any) => p.procedure_definition_details || [],
                            )
                            .map((p: any) => ({
                              id: p.procedure_definition_id,
                              name: p.procedure_definition_name,
                            }));
                        },
                      );

                      // Find common procedures across selected serials
                      let commonProcedures: { id: string; name: string }[] = [];
                      if (allProceduresPerSerial.length > 0) {
                        commonProcedures = allProceduresPerSerial.reduce(
                          (a: any[], b: any[]) =>
                            a.filter((x) => b.some((y) => y.id === x.id)),
                          allProceduresPerSerial[0],
                        );
                      }

                      // Remove duplicates
                      const uniqueProcedures = Array.from(
                        new Map(
                          commonProcedures.map((p) => [p.id, p]),
                        ).values(),
                      );

                      // Toggle logic
                      if (
                        selectedProcedures.length === uniqueProcedures.length
                      ) {
                        setSelectedProcedures([]);
                      } else {
                        setSelectedProcedures(
                          uniqueProcedures.map((p) => p.name),
                        );
                      }
                    }}
                  >
                    {(() => {
                      const selectedDetails =
                        selectedWorkorder?.details.filter((d: any) =>
                          selectedSerials.includes(d.serial_numbers),
                        ) || [];

                      const allProceduresPerSerial = selectedDetails.map(
                        (d: any) => {
                          return d.procedures
                            .filter((p: any) =>
                              selectedSequences.includes(p.procedure_name),
                            )
                            .flatMap(
                              (p: any) => p.procedure_definition_details || [],
                            )
                            .map((p: any) => ({
                              id: p.procedure_definition_id,
                              name: p.procedure_definition_name,
                            }));
                        },
                      );

                      let commonProcedures: { id: string; name: string }[] = [];
                      if (allProceduresPerSerial.length > 0) {
                        commonProcedures = allProceduresPerSerial.reduce(
                          (a: any[], b: any[]) =>
                            a.filter((x) => b.some((y) => y.id === x.id)),
                          allProceduresPerSerial[0],
                        );
                      }

                      const uniqueProcedures = Array.from(
                        new Map(
                          commonProcedures.map((p) => [p.id, p]),
                        ).values(),
                      );

                      return selectedProcedures.length ===
                        uniqueProcedures.length
                        ? "Deselect All"
                        : "Select All";
                    })()}
                  </MuiLink>
                </Grid>
              )}

              <Grid item style={{ marginLeft: "auto" }}>
                <MuiLink
                  style={{ cursor: "pointer", fontSize: 14 }}
                  onClick={() => setProcedureExpanded(!procedureExpanded)}
                >
                  {procedureExpanded ? "Hide All" : "View All"}
                </MuiLink>
              </Grid>
            </Grid>

            {procedureExpanded && (
              <Grid item>
                <Grid container spacing={1}>
                  {(() => {
                    const selectedDetails =
                      selectedWorkorder?.details.filter((d: any) =>
                        selectedSerials.includes(d.serial_numbers),
                      ) || [];

                    // Collect all procedures per serial for selected sequences
                    const allProceduresPerSerial = selectedDetails.map(
                      (d: any) => {
                        return d.procedures
                          .filter((p: any) =>
                            selectedSequences.includes(p.procedure_name),
                          )
                          .flatMap(
                            (p: any) => p.procedure_definition_details || [],
                          )
                          .map((p: any) => ({
                            id: p.procedure_definition_id,
                            name: p.procedure_definition_name,
                          }));
                      },
                    );

                    // Find common procedure_definition_details across selected serials
                    let commonProcedures: { id: string; name: string }[] = [];
                    if (allProceduresPerSerial.length > 0) {
                      commonProcedures = allProceduresPerSerial.reduce(
                        (a: any[], b: any[]) =>
                          a.filter((x) => b.some((y) => y.id === x.id)),
                        allProceduresPerSerial[0],
                      );
                    }

                    // Remove duplicates (if any)
                    const uniqueProcedures = Array.from(
                      new Map(commonProcedures.map((p) => [p.id, p])).values(),
                    );

                    return uniqueProcedures.map((item: any) => {
                      const isSelected = selectedProcedures.includes(item.name);
                      return (
                        <Grid item key={item.id}>
                          <Grid
                            container
                            alignItems="center"
                            justifyContent={
                              isSelected ? "flex-start" : "center"
                            }
                            onClick={() => handleProcedureToggle(item.name)}
                            style={{
                              minWidth: 200,
                              padding: "6px 12px",
                              border: isSelected
                                ? "1px solid #FFD27F"
                                : "1px solid #ccc",
                              backgroundColor: isSelected
                                ? "#FFD27F"
                                : "transparent",
                              color: "#000",
                              borderRadius: 10,
                              cursor: "pointer",
                              display: "flex",
                              gap: isSelected ? 4 : 0,
                              userSelect: "none",
                            }}
                          >
                            {isSelected && <CheckIcon fontSize="small" />}
                            <span
                              style={{
                                flex: 1,
                                textAlign: isSelected ? "left" : "center",
                              }}
                            >
                              {item.name}
                            </span>
                          </Grid>
                        </Grid>
                      );
                    });
                  })()}
                </Grid>
              </Grid>
            )}
          </Grid>
        </Paper>
      )}
      {/* Select Images */}
      {/* Select Images */}
      {selectedWorkorder && selectedProcedures.length > 0 && (
        <Paper elevation={2} style={{ padding: 10, margin: 10 }}>
          {(() => {
            const selectedDetails =
              selectedWorkorder?.details.filter((d: any) =>
                selectedSerials.includes(d.serial_numbers),
              ) || [];

            const images = Array.from(
              new Map(
                selectedDetails
                  .flatMap((d: any) => d.procedures)
                  .filter((p: any) =>
                    selectedSequences.includes(p.procedure_name),
                  )
                  .flatMap((p: any) => p.procedure_definition_details)
                  .filter((pd: any) =>
                    selectedProcedures.includes(
                      pd.procedure_definition_name,
                    ),
                  )
                  .flatMap((pd: any) => pd.images || [])
                  .map((img: any) => [img.image_id, img]),
              ).values(),
            );

            return (
              <Grid container spacing={2} direction="column">
                {/* Header */}
                <Grid item container alignItems="center" spacing={2}>
                  <Grid item>
                    <Typography
                      variant="subtitle1"
                      style={{
                        color: "#800280",
                        fontSize: 16,
                      }}
                    >
                      Select Images
                    </Typography>
                  </Grid>

                  {imageExpanded && (
                    <Grid item>
                      <Typography
                        variant="body2"
                        style={{
                          color: "#800280",
                          fontSize: 14,
                        }}
                      >
                        ({selectedImages.length} selected of {images.length})
                      </Typography>
                    </Grid>
                  )}

                  {imageExpanded && (
                    <Grid item>
                      <MuiLink
                        style={{
                          cursor: "pointer",
                          fontSize: 14,
                        }}
                        onClick={() => {
                          if (selectedImages.length === images.length) {
                            setSelectedImages([]);
                          } else {
                            setSelectedImages(images);
                          }
                        }}
                      >
                        {selectedImages.length === images.length
                          ? "Deselect All"
                          : "Select All"}
                      </MuiLink>
                    </Grid>
                  )}

                  <Grid item style={{ marginLeft: "auto" }}>
                    <MuiLink
                      style={{
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                      onClick={() =>
                        setImageExpanded(!imageExpanded)
                      }
                    >
                      {imageExpanded ? "Hide All" : "View All"}
                    </MuiLink>
                  </Grid>
                </Grid>

                {/* Images */}
                {imageExpanded && (
                  <Grid item>
                    <Grid container spacing={1}>
                      {images.map((image: any) => {
                        const selected = selectedImages.some(
                          (img) => img.image_id === image.image_id,
                        );

                        return (
                          <Grid item key={image.image_id}>
                            <Grid
                              onClick={() => {
                                setSelectedImages((prev) => {
                                  const exists = prev.some(
                                    (img) =>
                                      img.image_id === image.image_id,
                                  );

                                  if (exists) {
                                    return prev.filter(
                                      (img) =>
                                        img.image_id !==
                                        image.image_id,
                                    );
                                  }

                                  return [...prev, image];
                                });
                              }}
                              style={{
                                minWidth: 180,
                                padding: "6px 12px",
                                border: selected
                                  ? "1px solid #FFD27F"
                                  : "1px solid #ccc",
                                background: selected
                                  ? "#FFD27F"
                                  : "#fff",
                                borderRadius: 8,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                                userSelect: "none",
                              }}
                            >
                              {selected && (
                                <CheckIcon fontSize="small" />
                              )}

                              <span>{image.image_name}</span>
                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            );
          })()}
        </Paper>
      )}
      <Grid
        container
        justifyContent="center"
        spacing={2}
        style={{ marginTop: 24, marginBottom: 24 }}
      >
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handleInsert}
            disabled={selectedImages.length === 0}
          >
            {isDownloading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Insert"
            )}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
